import styled from 'styled-components';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import Theme from '../Theme';

const StyledReactTable = styled(ReactTable)`
  background: ${Theme.colors.white};
  display: block;
  width: ${(props) => props.width || 'auto'};

  &.ReactTable {
    border: none;
    div.rt-table { overflow: visible; }
    div.rt-thead {

      &.-headerGroups {
        border-bottom: none;

        .rt-tr {
          background: ${Theme.colors.white};
        }
      }

      &.-header {
        border-bottom: 1px solid ${Theme.colors.gray[8]};
        box-shadow: none;
        background: ${Theme.colors.white};
      }

      .rt-th {
        border-right: none;
        padding: 10px;
        height: 100%;
        background: ${Theme.colors.white};

        &.-sort-asc {
          position: relative;
          box-shadow: none;

          &::after {
            _border-color: #000000 #000000 #505759 #000000;
            _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
            border-color: transparent transparent #505759 transparent;
            border-style: solid;
            border-width: 0 3.5px 4px 3.5px;
            content: '';
            height: 0;
            line-height: 0px;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
          }
        }

        &.-sort-desc {
          position: relative;
          box-shadow: none;

          &::after {
            _border-color: #505759 #000000 #000000 #000000;
            _filter: progid:DXImageTransform.Microsoft.Chroma(color='#000000');
            border-color: #505759 transparent transparent transparent;
            border-style: solid;
            border-width: 4px 3.5px 0 3.5px;
            content: '';
            height: 0;
            line-height: 0px;
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            width: 0;
          }
        }
      }
    }
  }

  div.rt-tbody,
  div.rt-tfoot {
    overflow-y: hidden;
    box-shadow: none;

    .rt-tr-group {
      border-bottom: 1px solid ${Theme.colors.gray[8]};

      &:last-child: {
        border-bottom: 1px solid ${Theme.colors.gray[8]};
      }
    }

    .rt-td {
      border-right: none;
      padding: 10px;
    }
  }

  div.rt-tfoot {
    border-top: 1px solid ${Theme.colors.gray[8]};
  }

  .rt-resizable-header-content {
    height: 100%;
  }

  &.-striped {

    div.rt-tbody {
        background: ${Theme.colors.white};
      div.rt-tr {

        &:hover {
          background: ${Theme.colors.blue[0]} !important;

          div,
          a {
            color: ${Theme.colors.white} !important;
          }
        }

        &.-odd {
          background: ${Theme.colors.blue[1]};
        }
      }
    }
  }

  &.-highlight {

    div.rt-tbody {

      div.rt-tr {

        &:hover {
          background: ${Theme.colors.blue[0]} !important;

          div,
          a {
            color: ${Theme.colors.white} !important;
          }
        }
      }
    }
  }
`;

export default StyledReactTable;
